import { IVideo } from "~/types/video";

export const videos: IVideo[] = [
  {
    url: "https://staging.smartli.ai/Welcome+to+Smartli.mp4",
    titleKey: "video.install",
    time: "1:05",
    thumbnail: "/welcome.avif",
    title: "Welcome to Smartli",
  },
  {
    url: "https://staging.smartli.ai/AI+Ads+Writer.mp4",
    titleKey: "video.create_ads",
    time: "0:42",
    thumbnail: "/ads-writer.avif",
    title: "AI Ads Writer",
  },
  {
    url: "https://staging.smartli.ai/AI+Background+Remover.mp4",
    titleKey: "video.ai_background_remover",
    time: "0:43",
    thumbnail: "/bg-remover.avif",
    title: "AI Background Remover",
  },
  {
    url: "https://staging.smartli.ai/AI+Background+Generator.mp4",
    titleKey: "video.ai_background_generator",
    time: "0:43",
    thumbnail: "/bg-generator.avif",
    title: "AI Background Generator",
  },
  {
    url: "https://staging.smartli.ai/AI+Blogs+Writer.mp4",
    titleKey: "video.ai_blog_writer",
    time: "0:54",
    thumbnail: "/blog.avif",
    title: "AI Blogs Writer",
  },
  {
    url: "https://staging.smartli.ai/AI+Content+Humanizer.mp4",
    titleKey: "video.ai_content_humanizer",
    time: "0:26",
    thumbnail: "/content.avif",
    title: "AI Content Humanizer",
  },
  {
    url: "https://staging.smartli.ai/AI+Description+Generator.mp4",
    titleKey: "video.ai_descriptions",
    time: "0:46",
    thumbnail: "/description.avif",
    title: "AI Descriptions",
  },
  {
    url: "https://staging.smartli.ai/AI+Model+Photoshoots.mp4",
    titleKey: "video.ai_photoshoots",
    time: "0:35",
    thumbnail: "/model.avif",
    title: "AI Model Photoshoots",
  },
  {
    url: "https://staging.smartli.ai/AI+Photo+Enhancer.mp4",
    titleKey: "video.ai_photo_enhancer",
    time: "0:34",
    thumbnail: "/enhancer.avif",
    title: "AI Photo Enhancer",
  },
  {
    url: "https://staging.smartli.ai/AI+Watermark+Remover.mp4",
    titleKey: "video.ai_watermark_remover",
    time: "0:33",
    thumbnail: "/watermark.avif",
    title: "AI Watermark Remover",
  },
];
